<template>
	<div class="content-finish">
		<div class="mask" v-bind:style="{backgroundColor : color_botones }">
			<img src="https://info.vinapp.co/wp-content/uploads/2021/05/estrellas.png" alt="">
			<div class="check">
				<i class="fas fa-check" v-bind:style="{color : color_botones }"></i>
			</div>
			<h4 class="title">¡Gracias!</h4>
			<h4 class="subtitle">Ahora debes entrar a tu App Nequi, dar click en Notificaciones y aceptar el pago, luego comenzaremmos a preparar tu pedido 🥳</h4>
		</div>
		<div class="data-finish">
			<div class="content-order">
				<h4>Estado: {{ estado }}</h4>
				<h5>No. {{ idTransactionOnline }}</h5>
			</div>
			<div class="data-finish-client">
				<div class="both-data-finish">
					<h4>Nombre:</h4>
					<h5>{{ nombre }}</h5>
				</div>
				<div class="both-data-finish">
					<h4>Teléfono:</h4>
					<h5>{{ telefono }}</h5>
				</div>
			</div>
			<div class="order-finish-client">
				<div class="order-finish-detail">
					<div class="options">
						<h4>Detalle de orden</h4>
						<i class="fas fa-angle-down" @click="show()"></i>	
					</div>
					<div class="products-order">
						<li v-for="item in order_finish">{{ item.name_product }}</li>
					</div>
				</div>
				<div class="finish-order-total">
					<h4>Total:</h4>
					<h5>${{ Intl.NumberFormat("de-DE").format( total_cart) }}</h5>
				</div>
			</div>
		</div>
		<!--<div class="button-back-to-home" v-if="estado == 'PENDIENTE'">
			<button v-bind:style="{color : color_botones, borderColor: color_botones }" @click="reloadPayment()"><i class="fas fa-refresh" v-bind:style="{color : color_botones }"></i>{{ validarTexto }}</button>
		</div>
		<br>-->
		<div class="button-back-to-home" >
			<audio id="mymusic" src="http://localhost:8080/notification.mp3"></audio>
			<button v-bind:style="{color : color_botones, borderColor: color_botones }" @click="reload()"><i class="fas fa-home" v-bind:style="{color : color_botones }"></i>Volver a la tienda</button>
		</div>
		
	</div>
</template>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	.content-finish{
		width: 100%;
		height: auto;
		padding-bottom: 20px;
	}

	.mask{
		padding: 20px 0px;
		width: 100%;
		height: 45vh;
		/*border-bottom-left-radius: 120px;
		border-bottom-right-radius: 120px;*/
	}

	.mask img{
		width: 50%;
		animation: scala .7s ease-in-out;
	}

	.check{
		width: 62px;
		height: 62px;
		border-radius: 50%;
		background: #fff;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: -85px;	
	}

	.check i{
		font-size: 26px;
	}

	.title{
		padding-top: 35px;
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #fff;
		margin-bottom: 4px;
	}

	.subtitle{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 10px;
	}

	.data-finish{
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 8px 10px 0px rgba(215,215,215,1);
		margin-top:-75px;
		margin-bottom: 45px;
	}

	.content-order{
		border-bottom: 1px solid #f2f2f2;
		padding-top: 25px;
		padding-bottom: 10px;
	}

	.content-order h4{
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #000;
		margin-bottom: 4px;
	}

	.content-order h5{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
		margin-bottom: 2px;
	}

	.data-finish-client{
		width: 100%;
		height: auto;
		padding: 5px 0px;
		border-bottom: 1px solid #f2f2f2;
	}

	.both-data-finish{
		width: 100%;
		height: auto;
		padding: 5px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.both-data-finish h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}

	.both-data-finish h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}

	.finish-order-total{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.order-finish-detail{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		border-bottom: 1px solid #f2f2f2;
		transition: all .3s ease-in-out;
	}

	.options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.products-order{
		width: 100%;
		text-align: left;
		padding-left: 15px;
		padding-top: 10px;
		transition: all 3s ease-in-out;
	}

	.products-order li{
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}

	.order-finish-detail h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
		margin-bottom: 0;
	}

	.order-finish-detail i{
		margin-right: 5px;
		cursor: pointer;
	}

	.cart-finish-detail{
		width: 100%;
	}

	.height{
		height: 0px !important;
		overflow: hidden;
	}

	.finish-order-total h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}

	.finish-order-total h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}

	.button-back-to-home button{
		padding: 10px 25px;
		background:transparent;
		font-size: 17px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		border-radius: 5px;
	}

	.button-back-to-home button:focus{
		outline: none !important;
	}

	.button-back-to-home i{
		margin-right: 8px;
	}

	.rotate{
		transform: rotate(180deg);
	}

	@keyframes scala {
		from{
			transform: scale(0);
		}
		to{
			transform: scale(1);
		}
	}


</style>


<script>
	import axios from 'axios';
	export default{
		props: ['order_finish', 'idTransactionOnline'],
		data(){
			return{
				color_botones: localStorage.getItem('color_licencia'),
				sound: false,
				contador:0,
				total_cart:0,
				valor_domicilio:JSON.parse(localStorage.getItem('domicilio')),
				nombre: localStorage.getItem('nombre'),
				telefono : localStorage.getItem('telefono_nequi'),
				estado: "PENDIENTE",
				validarTexto: "Validar mi pago exitoso"
			}
		},
		methods:{
			reload(){
				location.reload();
			},
			reloadPayment(){
				this.validarTexto = "Validando mi pago..."
				axios.get(`https://back.vinapp.co/api/transactions/find-transaction/${this.idTransactionOnline}`)
				.then(res => {
					this.validarTexto = "Validar mi pago exitoso"
					let result = JSON.parse(res.data);
					this.estado = homologarEstados(result.data.status)
				})
				.catch(error => {
					this.validarTexto = "Validar mi pago exitoso"
				})
			},
			homologarEstados(e){
				if (e == "APPROVED") return "APROBADA";
				if (e == "DECLINED") return "RECHAZADA";
				if (e == "VOIDED") return "ANULADA";
				if (e == "ERROR") return "ERROR";
				if (e == "PENDING") return "PENDIENTE";
				return "DESCONOCIDO";
			},
			show(){
				if (this.contador == 0) {
					$(".products-order").addClass('height');
					$(".fa-angle-down").removeClass('rotate');
					this.contador++;	
				}else{
					$(".products-order").removeClass('height');
					$(".fa-angle-down").addClass('rotate');
					this.contador = 0;
				}
				
			}
		},
		mounted(){
			//calculamos el total de la orden
			this.order_finish.forEach((item) =>{
				this.total_cart += parseInt(item.valor, 10);
			});
			this.total_cart += this.valor_domicilio;
			this.contador = 1;
			$(".products-order").addClass('height');
		}
	}

</script>